import { render, staticRenderFns } from "./GenericHero.vue?vue&type=template&id=3231d10e&"
import script from "./GenericHero.vue?vue&type=script&lang=js&"
export * from "./GenericHero.vue?vue&type=script&lang=js&"
import style0 from "./GenericHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports